import React from 'react';
const benefits = [{
  emoji: '🥗',
  bold: 'Vas a abrir el freezer',
  rest: ' y tener todo listo sin pensar qué cocinar.'
}, {
  emoji: '💸',
  bold: 'Vas a ahorrar',
  rest: ' una fortuna en delivery cada mes.'
}, {
  emoji: '🧠',
  bold: 'Vas a liberar',
  rest: ' energía mental todos los días.'
}, {
  emoji: '🧼',
  bold: 'Vas a dejar de',
  rest: ' vivir limpiando hornallas y ollas.'
}, {
  emoji: '😌',
  bold: 'Vas a llegar a casa',
  rest: ' y simplemente calentar y comer en paz.'
}];
export function BenefitsSection() {
  return <section className="py-5 md:py-7 px-4 bg-white" data-id="element-19">
      <div className="max-w-2xl mx-auto" data-id="element-20">
        <h2 className="text-xl md:text-3xl text-center mb-4 md:mb-5 font-bold tracking-tight" data-id="element-21">
          ¿Qué vas a lograr con este sistema?
        </h2>

        <div className="space-y-2 md:space-y-2.5" data-id="element-22">
          {benefits.map((benefit, i) => <div key={i} className="bg-[#F7F5F0] rounded-2xl border-l-4 border-primary px-3 py-2 md:px-4 md:py-3 flex items-start gap-3 md:gap-4 shadow-sm" data-id="element-23">
              <span className="text-lg md:text-xl flex-shrink-0 mt-0.5" data-id="element-24">
                {benefit.emoji}
              </span>
              <p className="text-xs md:text-sm text-text-primary leading-relaxed font-medium" data-id="element-25">
                <strong className="font-bold" data-id="element-26">{benefit.bold}</strong>
                {benefit.rest}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}